import { Component } from '@angular/core';

@Component({
  templateUrl: './tos.component.html',
  styleUrls: ['../oss/oss.component.less']
})
export class TOSComponent {

}



// WEBPACK FOOTER //
// ./src/app/tos/tos.component.ts